import { useEffect, useState } from "react";
import { AutocompleteInput, ReferenceInput, useTranslate } from "react-admin";
import { useWatch, useFormContext } from "react-hook-form";
import CreateNewProduct from "./CreateNewProduct";

// detailType defaultnya all, atau setting jadi noZeroStock, atau noZeroRemain
const ProductInput = ({
  dependOn,
  source,
  reset,
  defaultFilters = {},
  detailType = "all",
  exclude = {},
  withCreate = true,
  ...props
}) => {
  const depend = useWatch({ name: dependOn });
  const { setValue } = useFormContext();
  const [first, setFirst] = useState(false);
  const t = useTranslate();

  useEffect(() => {
    if (first) {
      setFirst(true);
      setValue(source, undefined);
      for (let i = 0; i < reset.length; i++) {
        const sourceName = reset[i];
        setValue(sourceName, undefined);
      }
    }
  }, [depend, first]);

  return (
    <ReferenceInput
      source={source}
      reference="products/dropdown"
      // Increase perPage so the dropdown returns more items on first open
      // (was 100, bumped to 150 to surface more choices)
      perPage={150}
      sort={{ field: "products.code", order: "ASC" }}
      // Always include detail_type in the ReferenceInput filter so the
      // initial choices (when the dropdown first opens) are already filtered
      // server-side (e.g. hide zero-remaining items for `noZeroRemain`).
      filter={{ ...defaultFilters, ...exclude, detail_type: detailType }}
      // TODO semua ReferenceInput musti dihandle ketika searchText nya undefined seperti ini
      // enableGetChoices={(q) => {
      //   return q && !!q.code;
      // }}
    >
      <AutocompleteInput
        {...props}
        /**
        In development with React.StrictMode, you may run into an issue where the <AutocompleteInput> menu reopens
        after clicking the create item when the openOnFocus prop is set to true which is the default with React-admin.
        If that bothers you, set the openOnFocus prop to false.
         */
        openOnFocus={!withCreate}
        create={withCreate ? <CreateNewProduct /> : undefined}
        createLabel={
          withCreate ? t("mine.label.create_new_item") : undefined
        }
        createItemLabel={
          withCreate ? t("mine.label.create_new_item") + ": %{item}" : undefined
        }
        filterToQuery={(searchText) => {
          // Always include detail_type so initial open (no searchText)
          // will still apply the server-side filter (e.g. noZeroRemain)
          if (searchText) {
            return { code: searchText, detail_type: detailType };
          }
          // Saat tidak ada input ketik (dropdown baru dibuka / setelah pilih),
          // JANGAN kirim nilai source karena isinya UUID bukan product code.
          // Cukup kirim detail_type agar semua produk valid tampil.
          return { detail_type: detailType };
        }}
      />
    </ReferenceInput>
  );
};
// const propsAreEqual = (prevProps, nextProps) => {
//   if (
//     // prevProps.dependOn === nextProps.dependOn &&
//     prevProps.source === nextProps.source
//   ) {
//     // tidak perlu render ulang
//     return true;
//   }
//   // perlu dirender ulang
//   return false;
// };
export default ProductInput; // memo(ProductInput, propsAreEqual);
